// extracted by mini-css-extract-plugin
export default {"container":"InactiveAccount_container__GXOZ4","content":"InactiveAccount_content__H9bcu","actionsRow":"InactiveAccount_actionsRow__qiaIy"};